import { gql } from '@apollo/client';

export const ALL_CITIES = gql`
  query allCities($input: NameSearchArgs!) {
    cities: getCities(input: $input) {
      id
      name
    }
  }
`;
